import { Link } from "react-router-dom";
import "../styles/index.css"; 
import { useEffect } from "react";

export const Home = () => {

  useEffect(() => {
    const slides = Array.from(document.querySelectorAll(".mySlides"));
    let i = 0;
    const tick = () => {
      slides.forEach(s => s.classList.remove("active"));
      slides[i].classList.add("active");
      i = (i + 1) % slides.length;
    };
    tick(); // show first
    const id = setInterval(tick, 3000);
    return () => clearInterval(id);
  }, []);
  
  return (
    <>
      <div className="main_content">
        <section>
          <div className="about_container">
            <h2>Amigo's Gitaro's</h2>
            <p className="intro-text">
                Wij zijn de Amigo’s Gitaro’s!
                Vier muziekvrienden die het leuk vinden om muziek te spelen en dit te delen met iedereen die van muziek houdt.
                Wij spelen allerlei soorten muziek voor een gezellig ‘meezing’ optreden, variërend van ‘Het kleine café aan de haven’, Het land van Maas en Waal, Country Roads, Can’t  help falling in Love, Mary Lou, Proud Mary en nog veel en veel meer! Ons repertoire beslaat op dit moment 50 meezingnummers……!
                Dus heb je een vraag / interesse over onze optredens? Laat vooral weten en vul het contactformulier in.
                Dan nemen wij contact met je op!
            </p> 
            <Link to="/about"><button>Meer Info</button></Link>
          </div>
        </section>
        <section>
          <div className="pictures_container">
            <img className="mySlides" src="/images/flyerfoto.jpg" alt=""/>
            <img className="mySlides" src="/images/DSCF2572.jpeg" alt=""/>
            <img className="mySlides" src="/images/DSCF2745.jpeg" alt=""/>
            <img className="mySlides" src="/images/DSCF2750.jpeg" alt=""/>
            <img className="mySlides" src="/images/DSCF2968.jpeg" alt=""/>
            <img className="mySlides" src="/images/DSCF3082.jpeg" alt=""/>
          </div>
        </section>
        <section>
            <div className="book_container">
                <p>Vragen? Mail ons op <a href="mailto:amigosgitarosinfo@gmail.com" >amigosgitarosinfo@gmail.com</a>.</p>
            </div>
        </section>
      </div>
    </>        
  )
}
